import { useState } from "react";
import { Loader2 } from "lucide-react";

const UNITS = ["kg", "gm", "l", "ml", "pcs", "dozen", "carton", "case", "pack", "bag", "box", "bunch"];

// Edit the quantity / unit read from the bill. Saved through the canonical DRAFT update.
export const SourceEditor = ({ line, onSave, onCancel, busy }) => {
  const [qty, setQty] = useState(String(line.raw_quantity ?? ""));
  const [unit, setUnit] = useState(line.raw_unit || "");
  const [err, setErr] = useState(null);
  const qid = `src-qty-${line.line_id}`;
  const uid = `src-unit-${line.line_id}`;

  const save = (e) => {
    e.preventDefault();
    const n = Number(qty);
    if (!Number.isFinite(n) || n <= 0) return setErr("Enter a quantity greater than 0");
    const changes = {};
    if (n !== Number(line.raw_quantity)) changes.item_quantity = n;
    if (unit !== (line.raw_unit || "")) changes.item_unit = unit;
    if (!Object.keys(changes).length) return onCancel();
    setErr(null);
    onSave(changes);
  };

  const units = UNITS.includes(line.raw_unit) || !line.raw_unit ? UNITS : [line.raw_unit, ...UNITS];
  return (
    <form onSubmit={save} className="mt-3 space-y-3 rounded-md border border-[#E4E0D8] bg-archival-soft p-3" data-testid={`source-editor-${line.line_id}`} noValidate>
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-1 min-w-0">
          <label htmlFor={qid} className="text-[13px] font-medium text-archival-primary">Quantity</label>
          <input id={qid} data-testid={`source-qty-${line.line_id}`} inputMode="decimal" value={qty}
            onChange={(e) => setQty(e.target.value)} aria-invalid={!!err} aria-describedby={err ? `${qid}-err` : undefined}
            className="w-full h-12 px-3 rounded-md border border-[#E4E0D8] bg-white text-[16px] font-mono focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--action)]" />
        </div>
        <div className="space-y-1 min-w-0">
          <label htmlFor={uid} className="text-[13px] font-medium text-archival-primary">Unit</label>
          <select id={uid} data-testid={`source-unit-${line.line_id}`} value={unit} onChange={(e) => setUnit(e.target.value)}
            className="w-full h-12 px-2 rounded-md border border-[#E4E0D8] bg-white text-[16px] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--action)]">
            {units.map((u) => <option key={u} value={u}>{u}</option>)}
          </select>
        </div>
      </div>
      {err && <p id={`${qid}-err`} role="alert" className="text-[13px] text-red-700">{err}</p>}
      <div className="flex gap-2">
        <button type="submit" disabled={busy} data-testid={`source-save-${line.line_id}`}
          className="h-12 px-5 rounded-md text-white text-[15px] font-semibold disabled:opacity-60" style={{ backgroundColor: "var(--action)" }}>
          {busy ? <Loader2 size={16} className="animate-spin" /> : "Save"}
        </button>
        <button type="button" onClick={onCancel} data-testid={`source-cancel-${line.line_id}`}
          className="h-12 px-4 rounded-md border border-[#E4E0D8] bg-white text-[15px]">Cancel</button>
      </div>
    </form>
  );
};
